export const teamMembers = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "President",
    major: "Computer Engineering",
    year: "Senior",
    image: "https://images.unsplash.com/photo-1596496356933-9b6e0b186b88?crop=entropy&cs=srgb&fm=jpg&q=85",
    bio: "Passionate about ASIC design and verification methodologies"
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    role: "Vice President",
    major: "Electrical Engineering",
    year: "Junior",
    image: "https://images.pexels.com/photos/9242823/pexels-photo-9242823.jpeg?auto=compress&cs=tinysrgb",
    bio: "Specializes in analog circuit design and VLSI systems"
  },
  {
    id: 3,
    name: "Emily Thompson",
    role: "Technical Lead",
    major: "Computer Engineering",
    year: "Senior",
    image: "https://images.pexels.com/photos/9242841/pexels-photo-9242841.jpeg?auto=compress&cs=tinysrgb",
    bio: "Focused on RTL design and synthesis optimization"
  },
  {
    id: 4,
    name: "David Patel",
    role: "Outreach Director",
    major: "Electrical Engineering",
    year: "Sophomore",
    image: "https://images.unsplash.com/photo-1686624386665-4cd01b96d0f6?crop=entropy&cs=srgb&fm=jpg&q=85",
    bio: "Building bridges between students and industry leaders"
  }
];

export const facultyAdvisors = [
  {
    id: 1,
    name: "Dr. Steven Bibyk",
    title: "Professor of Electrical Engineering",
    department: "Department of ECE",
    specialty: "Analog Systems and Circuits",
    image: "https://customer-assets.emergentagent.com/job_chip-design-hub-3/artifacts/t64jeu9a_image-Picsart-AiImageEnhancer.png",
    email: "bibyk.1@osu.edu",
    bio: "Dr. Steven B. Bibyk is an Associate Professor of Electrical and Computer Engineering at The Ohio State University, where he has served on the faculty since 1984. He holds a combined B.S./M.S. in Electrical Engineering and Applied Physics from Case Western Reserve University, and previously worked at Mostek, Sandia National Laboratories, and NASA's Lewis Research Center. His research focuses on trust and assurance of secure electronic systems, rapid prototyping of embedded systems, and CMOS microelectronics. He serves as a Faculty Advisor to Buckeye Silicon."
  },
  {
    id: 2,
    name: "Dr. Ayman Fayed",
    title: "Professor of Electrical Engineering",
    department: "Department of ECE",
    specialty: "Analog, Mixed-Signal & Power Management IC Design",
    image: "https://customer-assets.emergentagent.com/job_chip-design-hub-3/artifacts/7m90me7d_IMG_3938.png",
    email: "fayed.1@osu.edu",
    bio: "Dr. Fayed is an expert in analog, mixed-signal, and power management integrated circuit design, with nine years of prior industry experience at Texas Instruments. He is the founder and director of Ohio State's Power Management Research Lab. His current research focuses on on-chip power supplies for dynamic energy distribution in Systems-on-Chip (SoCs) and multi-core CPUs, high-frequency switching regulators with on-chip and on-package passives, low-noise power supplies for analog and RF circuits, energy-harvesting platforms for power-restricted and remotely-deployed systems, and fully-integrated power converters in SiC and GaN technologies."
  }
];

export const mockContactSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted (MOCK):', formData);
      resolve({
        success: true,
        message: 'Thank you for your interest! We will contact you soon.',
        data: formData
      });
    }, 1000);
  });
};
